import type { ApplicationPhaseType } from '@/types/ClientApplication';
import type { StatusList } from '@/types/Shared';
import type { DeliverableTableHeaderInterface, MilestoneTableHeaderInterface, TaskTableHeaderInterface } from '@/types/Tdm';

export const developerApplicationStatus = {
  SUBMITTED: 'SUBMITTED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  DOCUMENT_REQUESTED: 'DOCUMENT_REQUESTED',
  HOLD: 'HOLD',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
};

export const clientApplicationStatus = {
  SUBMITTED: 'SUBMITTED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  DOCUMENT_REQUESTED: 'DOCUMENT_REQUESTED',
  HOLD: 'HOLD',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
};

export enum ClientAccount {
  CHICAGOREBUILD = 'CHICAGOREBUILD',
  LETS_BUILD_ACCELERATOR = 'LETSBUILDACCELERATOR',
}

export const tasksTableHeader: TaskTableHeaderInterface[] = [
  { name: 'Task', customClassName: 'w-72' },
  { name: 'Status', customClassName: 'w-32' },
  { name: 'Lead', customClassName: 'w-40' },
  { name: 'Support', customClassName: 'w-40' },
  { name: 'Vendor', customClassName: 'w-40' },
  { name: 'Due Date', customClassName: 'w-32' },
  { name: 'Actions', customClassName: 'w-32' },
];

export const deliverablesTableHeader: DeliverableTableHeaderInterface[] = [
  { name: 'Deliverable', customClassName: 'w-72' },
  { name: 'Status', customClassName: 'w-36' },
  { name: 'Lead', customClassName: 'w-40' },
  { name: 'Support', customClassName: 'w-40' },
  { name: 'Vendor', customClassName: 'w-40' },
  { name: 'Due Date', customClassName: 'w-24' },
  { name: 'Actions', customClassName: 'w-24' },
];

export const milestonesTableHeader: MilestoneTableHeaderInterface[] = [
  { name: 'Milestone', customClassName: 'w-72' },
  { name: 'Status', customClassName: 'w-36' },
  { name: 'Lead', customClassName: 'w-40' },
  { name: 'Support', customClassName: 'w-40' },
  { name: 'Vendor', customClassName: 'w-40' },
  { name: 'Due Date', customClassName: 'w-24' },
  { name: 'Actions', customClassName: 'w-24' },
];

export const dueDiligenceList: {
  label: string;
  value: ApplicationPhaseType;
}[] = [
  { label: 'Due Diligence 1', value: 'DILIGENCE_1' },
  { label: 'Due Diligence 2', value: 'DILIGENCE_2' },
  { label: 'Due Diligence 3', value: 'DILIGENCE_3' },
];

export const resourceTableHeader = [
  { name: 'Name', customClassName: 'w-72' },
  { name: 'Type', customClassName: 'w-36' },
  { name: 'Created At', customClassName: 'w-72' },
  { name: 'Actions', customClassName: 'w-36' },
];

export const statusChangeList: StatusList[] = [
  { label: 'Submitted', value: 'SUBMITTED' },
  { label: 'Under Review', value: 'UNDER_REVIEW' },
  { label: 'Initial Vetting', value: 'INITIAL_VETTING' },
  { label: 'Document Review', value: 'DOCUMENT_REVIEW' },
  { label: 'Document Requested', value: 'DOCUMENT_REQUESTED' },
  { label: 'Awaiting 3rd Party Report', value: 'AWAITING_3RD_PARTY_REPORT' },
  { label: 'Financial Underwriting', value: 'FINANCIAL_UNDERWRITING' },
  { label: 'Project Underwriting', value: 'PROJECT_UNDERWRITING' },
  { label: 'Partner Underwriting', value: 'PARTNER_UNDERWRITING' },
  { label: 'Physical Inspection', value: 'PHYSICAL_INSPECTION' },
  { label: 'Applicant Underwriting', value: 'APPLICANT_UNDERWRITING' },
  { label: 'Reference Checking', value: 'REFERENCE_CHECKING' },
  { label: 'Internal Review', value: 'INTERNAL_REVIEW' },
  { label: 'Hold', value: 'HOLD' },
  { label: 'Denied', value: 'DENIED' },
  { label: 'Approved', value: 'APPROVED' },
];
